<app-page-title icon="fa-bar-chart" title="Métricas de Ligações"></app-page-title>

<!-- Origem da ligação. "Todos" é a soma exata das outras duas abas. -->
<ul class="nav nav-tabs mt-3" role="tablist">
  <li class="nav-item" role="presentation">
    <a class="nav-link"
       role="tab"
       tabindex="0"
       [class.active]="activeTab === 'all'"
       [attr.aria-selected]="activeTab === 'all'"
       (click)="onTabChange('all')"
       (keydown.enter)="onTabChange('all')">
      <i class="fa fa-phone me-1"></i> Todos
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link"
       role="tab"
       tabindex="0"
       [class.active]="activeTab === 'broadcast'"
       [attr.aria-selected]="activeTab === 'broadcast'"
       (click)="onTabChange('broadcast')"
       (keydown.enter)="onTabChange('broadcast')">
      <i class="fa fa-bullhorn me-1"></i> Broadcasts
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link"
       role="tab"
       tabindex="0"
       [class.active]="activeTab === 'automation'"
       [attr.aria-selected]="activeTab === 'automation'"
       (click)="onTabChange('automation')"
       (keydown.enter)="onTabChange('automation')">
      <i class="fa fa-sitemap me-1"></i> Automações
    </a>
  </li>
</ul>

<!-- Filters -->
<div class="card">
  <div class="card-body">
    <!-- Date filter. Em "Todos" não há filtro de id embaixo, então a margem
         inferior sai junto para o card não ficar com uma faixa vazia. -->
    <div class="d-flex flex-wrap gap-2 align-items-center" [class.mb-3]="activeTab !== 'all'">
      <button
        class="btn btn-sm"
        [ngClass]="dateFilter === 'today' ? 'btn-primary' : 'btn-outline-secondary'"
        (click)="dateFilter = 'today'; applyFilter()"
      >Hoje</button>
      <button
        class="btn btn-sm"
        [ngClass]="dateFilter === '7d' ? 'btn-primary' : 'btn-outline-secondary'"
        (click)="dateFilter = '7d'; applyFilter()"
      >7 dias</button>
      <button
        class="btn btn-sm"
        [ngClass]="dateFilter === '30d' ? 'btn-primary' : 'btn-outline-secondary'"
        (click)="dateFilter = '30d'; applyFilter()"
      >30 dias</button>
      <button
        class="btn btn-sm"
        [ngClass]="dateFilter === 'custom' ? 'btn-primary' : 'btn-outline-secondary'"
        (click)="dateFilter = 'custom'"
      >Personalizado</button>

      <ng-container *ngIf="dateFilter === 'custom'">
        <mat-form-field style="width: 150px">
          <mat-label>Data inicial</mat-label>
          <input matInput [matDatepicker]="pickerStart" [(ngModel)]="customStartDate" />
          <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>
        <mat-form-field style="width: 150px">
          <mat-label>Data final</mat-label>
          <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="customEndDate" />
          <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
        <button class="btn btn-sm btn-primary" (click)="applyFilter()">
          <i class="fa fa-search"></i> Aplicar
        </button>
      </ng-container>
    </div>

    <!-- Broadcast filter -->
    <div class="d-flex flex-wrap gap-2 align-items-center" *ngIf="activeTab === 'broadcast'">
      <label class="mb-0 filter-label"><i class="fa fa-phone me-1"></i> Broadcast:</label>
      <mat-form-field style="width: 300px;">
        <input
          type="text"
          matInput
          placeholder="Pesquisar broadcast..."
          [formControl]="broadcastSearchCtrl"
          [matAutocomplete]="autoBroadcast"
        />
        <button
          *ngIf="selectedBroadcastId"
          mat-icon-button
          matSuffix
          type="button"
          (click)="clearBroadcastFilter()"
          title="Limpar filtro"
          style="font-size: 0.85rem;"
        >
          <i class="fa fa-times"></i>
        </button>
        <mat-autocomplete
          #autoBroadcast="matAutocomplete"
          [displayWith]="displayNameFn"
          (optionSelected)="onBroadcastSelected($event)"
          class="green-autocomplete-panel"
        >
          <mat-option *ngFor="let bc of filteredBroadcasts$ | async" [value]="bc">
            {{ bc.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <!-- Automation filter -->
    <div class="d-flex flex-wrap gap-2 align-items-center" *ngIf="activeTab === 'automation'">
      <label class="mb-0 filter-label"><i class="fa fa-sitemap me-1"></i> Automação:</label>
      <mat-form-field style="width: 300px;">
        <input
          type="text"
          matInput
          placeholder="Pesquisar automação..."
          [formControl]="automationSearchCtrl"
          [matAutocomplete]="autoAutomation"
        />
        <button
          *ngIf="selectedAutomationId"
          mat-icon-button
          matSuffix
          type="button"
          (click)="clearAutomationFilter()"
          title="Limpar filtro"
          style="font-size: 0.85rem;"
        >
          <i class="fa fa-times"></i>
        </button>
        <mat-autocomplete
          #autoAutomation="matAutocomplete"
          [displayWith]="displayNameFn"
          (optionSelected)="onAutomationSelected($event)"
          class="green-autocomplete-panel"
        >
          <mat-option *ngFor="let automation of filteredAutomations$ | async" [value]="automation">
            <span>{{ automation.name }}</span>
            <small class="option-hint">
              {{ automation.voice_sequences_count }}
              {{ automation.voice_sequences_count === 1 ? 'passo de voz' : 'passos de voz' }}
            </small>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
</div>

<!--
  A janela de tempo significa coisas diferentes em cada origem, e o usuário
  precisa saber disso antes de comparar um card com o outro: broadcast é um
  evento com data de criação; automação dispara continuamente e é recortada pela
  data da ligação. A aba "Todos" soma as duas e diz isso na cara.
-->
<div class="period-note mt-2">
  <i class="fa fa-calendar-o me-1"></i>
  <ng-container *ngIf="activeTab === 'all'">
    Consolidado das duas origens — é a soma exata das abas Broadcasts e Automações.
    Cada uma recorta o período do seu jeito: broadcast pela <strong>criação do disparo</strong>, automação pela <strong>data da ligação</strong>.
  </ng-container>
  <ng-container *ngIf="activeTab === 'broadcast'">
    O período filtra a data de <strong>criação do broadcast</strong> — um disparo criado em 31/07 que ligou em 02/08 conta em julho.
  </ng-container>
  <ng-container *ngIf="activeTab === 'automation'">
    O período filtra a <strong>data da ligação</strong> — a automação pode ter sido criada bem antes.
  </ng-container>
</div>

<app-skeleton *ngIf="loading" variant="card" [count]="4"
  label="Carregando as métricas de ligação" data-testid="metrics-loading"></app-skeleton>

<!-- Metric cards -->
<div class="row mt-3 metric-grid" *ngIf="!loading">

  <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
    <div class="metric-card">
      <div class="metric-info">
        <span class="metric-value">{{ metrics.total_calls | number }}</span>
        <span class="metric-title">Total de Ligações</span>
      </div>
      <div class="metric-icon">
        <i class="fa fa-phone"></i>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-4 col-sm-6 mb-3" *ngIf="showBroadcastCount">
    <div class="metric-card">
      <div class="metric-info">
        <span class="metric-value">{{ broadcastMetrics.total_broadcasts | number }}</span>
        <span class="metric-title">Total de Broadcasts</span>
      </div>
      <div class="metric-icon">
        <i class="fa fa-bullhorn"></i>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-4 col-sm-6 mb-3" *ngIf="showAutomationCount">
    <div class="metric-card">
      <div class="metric-info">
        <span class="metric-value">{{ automationMetrics.total_automations | number }}</span>
        <span class="metric-title">Total de Automações</span>
      </div>
      <div class="metric-icon">
        <i class="fa fa-sitemap"></i>
      </div>
    </div>
  </div>

  <!-- Só na aba Automações: uma automação pode ter vários passos que discam. -->
  <div class="col-lg-3 col-md-4 col-sm-6 mb-3" *ngIf="activeTab === 'automation'">
    <div class="metric-card">
      <div class="metric-info">
        <span class="metric-value">{{ automationMetrics.total_sequences | number }}</span>
        <span class="metric-title">Passos de Voz que Ligaram</span>
      </div>
      <div class="metric-icon icon-info">
        <i class="fa fa-list-ol"></i>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
    <div class="metric-card">
      <div class="metric-info">
        <span class="metric-value">{{ answerRate }}</span>
        <span class="metric-title">Taxa de Atendimento</span>
      </div>
      <div class="metric-icon">
        <i class="fa fa-check-circle"></i>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
    <div class="metric-card">
      <div class="metric-info">
        <span class="metric-value">{{ metrics.total_refused | number }}</span>
        <span class="metric-title">Recusada / Não Atendida</span>
      </div>
      <div class="metric-icon icon-muted">
        <i class="fa fa-ban"></i>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
    <div class="metric-card">
      <div class="metric-info">
        <span class="metric-value">{{ metrics.total_answered_hangup | number }}</span>
        <span class="metric-title">Atendida e Desligada</span>
      </div>
      <div class="metric-icon icon-warning">
        <i class="fa fa-sign-out"></i>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
    <div class="metric-card">
      <div class="metric-info">
        <span class="metric-value">{{ metrics.total_answered_dtmf | number }}</span>
        <span class="metric-title">Atendida com Digitação</span>
      </div>
      <div class="metric-icon icon-info">
        <i class="fa fa-keyboard-o"></i>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
    <div class="metric-card">
      <div class="metric-info">
        <span class="metric-value">{{ metrics.total_answered_listened | number }}</span>
        <span class="metric-title">Atendida e Escutada até o Fim</span>
      </div>
      <div class="metric-icon icon-success">
        <i class="fa fa-headphones"></i>
      </div>
    </div>
  </div>

</div>
